<template lang="html">
   <div id="sidePage" :class="sidestate" @click.self="pageClose">
        <SideOne ref="side1"
           @modelClose="sideClose"
           @transMove="transMove"
           @goSeek="goSeek"
           @cleanSelect="cleanSelect"
          :inDat="inDat"
          :selectedArr="selectedArr" />
        <SideTwo ref="inSide1" @modelClose="actClean(1)" :inDat="inDat" :inType="1" @selected="selectedChange"/>
        <SideTwo ref="inSide2" @modelClose="actClean(2)" :inDat="inDat" :inType="2" @selected="selectedChange"/>
        <SideTwo ref="inSide3" @modelClose="actClean(3)" :inDat="inDat" :inType="3" @selected="selectedChange"/>
        <SideTwo ref="inSide4" @modelClose="actClean(4)" :inDat="inDat" :inType="4" @selected="selectedChange"/>
        <SideTwo ref="inSide5" @modelClose="actClean(5)" :inDat="inDat" :inType="5" @selected="selectedChange"/>
   </div>
</template>

<script>
import SideOne from './SidePage1';
import SideTwo from './SidePage2';
export default {
     props:['inDat'],
     components:{
         SideOne,
         SideTwo
     },
     data(){
          return{
              sidestate:'',
              sideDat:'',
              selectedArr:[[],[],[],[],[]],
              sideAct:''
          }
     },
     methods:{
          sideOpen:function(){
              this.sidestate = 'act';
              this.$refs.side1.sideOpen();
          },
          sideClose:function(){
              this.sidestate = 'hide';
          },
          transMove:function(e){
              this.sideAct = e.intype;
              this.$refs['inSide' + e.intype].sideOpen();
          },
          selectedChange:function(e){
              this.selectedArr.splice(e.type-1,1,e.data);
          },
          goSeek:function(){
              this.$emit("goSeek",this.selectedArr);
          },
          pageClose:function(){
              if(this.sideAct){
                  this.$refs['inSide' + this.sideAct].sideClose();
              }else{
                  this.$refs.side1.sideClose();
              }
          },
          actClean:function(){
              this.sideAct = '';
          },
          cleanSelect:function(){
              for(let i = 0;i < this.selectedArr.length;i++){
                  this.selectedArr.splice(i,1,[]);
                  this.$refs['inSide' + (i + 1)].selectClean();
              }
              this.goSeek();
              this.$refs.side1.sideClose();
          }
     }
}
</script>

<style lang="css" scoped>

#sidePage{
     position: fixed;
     width: 100%;
     height: 100%;
     background: rgba(0,0,0,0.6);
     left: 0px;
     top: 0px;
     opacity: 0;
     z-index: -1;


}

#sidePage.act{
     transition-property: opacity;
     transition-duration: 0.2s;
     z-index: 90;
     opacity: 1;
}

#sidePage.hide{
     transition-property: all;
     transition-duration: 0.2s;
     transition-delay: 0.3s;
     z-index: -1;
     opacity: 0;
}


</style>
